import { EsDieIcon } from './EsDieIcon';
import './EsLoading.css';

/**
 * The loading message with a tumbling d20 beside it. The message is a live
 * region and in the DOM from the first render, so a screen reader hears it and
 * a test finds it; the die and the text fade in after 150ms (EsLoading.css), so
 * a fast load never flashes. size="lg" is the full-page variant.
 */
export function EsLoading( { children, size = 'sm', className = '', 'data-testid': dataTestId } ) {
    return (
        <div className={ ( 'esLoading ' + className ).trim() } data-size={ size } data-testid={ dataTestId }
             role="status" aria-live="polite">
            <EsDieIcon sides={ 20 } className="esLoadingDie" />
            <span>{ children }</span>
        </div>
    );
}
